let local = "Brival";

export default {
    general: {
        titleWindowsExplorer: 'MIL SABORES',
        iconWindowsExplorer: '',
        loaderImage: 'Cargando...', //require('./images/loader/831.gif'),
        loaderBackground: 'rgba(215,160,0, 0.1)',
        loaderColor: 'text-white',
        business: 1,
        imagesPath: 'brial',
        // currency:'CLP',
        pricetype: '$',
        localStorageNamed: local + 'E-commerce',
    },

    icons: {
        add : "fa fa-plus",
        //menu: 'fas fa-bars fa-2x',
        user: 'fas fa-user',
        password: 'fa fa-unlock-alt',
        search: 'fas fa-search fa-2x',
        shoppingCart: 'fas fa-shopping-cart fa-7x',
        signature: 'fa fa-signature',
        building: 'fa fa-building',
        phone: 'fa fa-phone',
        pin: 'fa fa-map-pin',
        road: 'fa fa-road',
        map: 'fa fa-map',
        city: 'fa fa-city',
        envelope: 'fa fa-envelope-open-text',
        globalAmericas: 'fa fa-globe-americas',
        shield: 'fa fa-shield',
        favorite: "fas fa-heart",
        trash: "fa fa-trash",
        backOrderTrue: 'fa fa-plus',
        backOrderFalse: 'fa fa-minus',
        arrowLeft: 'fas fa-caret-left',
        arrowRight: 'fas fa-caret-right',
        datasheet: 'far fa-file-pdf fa-2x',
        word: 'fas fa-file-word fa-2x',
        cfdi: 'fas fa-file-invoice-dollar',
        report: 'fas fa-file-pdf',
        xml: 'fas fa-file-alt',
        detail: 'fas fa-info-circle',   
        suscription: 'fas fa-chevron-circle-right',
        select : 'fas fa-check',
        filter: 'fa fa-filter',
    },

    trademarks:{
        marcasRegistradas: require('../../images/irco/trademarks.png'),
        pagoTarjeta: require('../../images/brival/HOME/Metodos-de-pago.svg'),
        enviosRepublica: require('../../images/brival/HOME/Envios.svg'),
        comprasSeguras: require('../../images/brival/HOME/Compra-segura.svg'),
        // prmoRed: require('../../images/irco/promored.png'),
        // buscados: require('../../images/irco/+buscados.png'),
        disponible: require('../../images/irco/nuevamente-disponibles.png'),
        nuestraTarjeta: require('../../images/irco/Tarjeta-Zona-Redcompensas.png'),
        // refrigeracionIndustrial: require('../../images/irco/Descubre2.png'),
    },

    navBar: {
        icon: require('../../images/brival/Navbar/Nav-logo2.svg'),
        icono2Login: require('../../images/brival/Login/compra-segura-login.svg'),
        searchAdvanced: require('../../images/brival/Navbar/Busqueda-avanzada.svg'),
        menu: require('../../images/brival/Navbar/Menu.svg'),
        shoppingCart: require('../../images/brival/Navbar/Carrito.svg'),
        backgroundColor: '#fff',
        iconColor: '#FFED00',
        iconColor2: '#FFFFFF',        
        iconColor3: '#666666',
        iconColor4: '#212529',
        iconColorPaginacion: "#E3E3E3",
        textColorPaginacion: "#666666",
        textColor2:'White',
        textColorBlack: 'black',
        textCategories: 'black',
        menuCategoriesBackground: '#fff',
        textColorCategorie: 'black',
        //cambio aqui al color del hover
        menuCategoriesBackgroundHover: '#ffed00',
        backgroundHover1: '#212529',
        textColorCategorieHover: 'black',
        iconModal: '#000000',
        iconModal2: '#FFED00',
        iconBackground: '#000000',
        principalColor: '#ffed00',
        iconSearch: require('../../images/brival/Navbar/Busqueda-avanzada.svg'),
        carrito: require('../../images/brival/Navbar/Carrito.svg'),
        avatar: require('../../images/brival/Navbar/Avatar_principal.svg'),
        iconBrands: require('../../images/brival/Navbar/iconsBrands.svg'),
        iconTemperature: require('../../images/brival/Navbar/iconsTemperature.svg'),
        iconCategory: require('../../images/brival/Navbar/iconsCategory.svg'),
    },

    shoppingCartIcons: {
        camionAgotado: require('../../images/brival/iconosCarrito/carrito-01.png'),
        camionVerde: require('../../images/brival/iconosCarrito/carrito-02.png'),
        camionAmarillo: require('../../images/brival/iconosCarrito/carrito-03.png'),
        carritoVerde: require('../../images/brival/iconosCarrito/carrito-04.png'),
        carritoAgotado: require('../../images/brival/iconosCarrito/carrito-05.png'),
        carritoAmarillo: require('../../images/brival/iconosCarrito/carrito-06.png')
    },
    shoppingCartView:{
        bgButton: '#EFC307',
        colorText: 'black',
    },

    NavarIconos: {
        iconOne: require('../../images/irco/marcas/nav_1.png'),
        iconTwo: require('../../images/irco/marcas/nav_2.png'),
        iconThree: require('../../images/irco/marcas/nav_3.png'),
        // iconFour: require('../../images/irco/marcas/nav_4.png'),
        iconFour: require('../../images/brival/marcas/infoCuenta.svg'),
        iconFive: require('../../images/irco/marcas/nav_5.png'),
    },
    //-------------------------------Estilos de reportes------------------------------
    reportViews: {
        fontSize : '1rem',
        width: '250px',
        textColorB: '#000000',
        bgReportsBlack:'#000000',
        textColorW: '#000000',
    },
    //-------------------------------Estilos de reportes----------------------------

    marcasScroll: {
        One: require('../../images/brival/marcasCarousel/Brands_1.png'),
        Two: require('../../images/brival/marcasCarousel/Brands_2.png'),
        Three: require('../../images/brival/marcasCarousel/Brands_3.png'),
        Four: require('../../images/brival/marcasCarousel/Brands_4.png'),
        Five: require('../../images/brival/marcasCarousel/Brands_5.png'),
        Six: require('../../images/brival/marcasCarousel/Brands_6.png'),
        Seven: require('../../images/brival/marcasCarousel/Brands_7.png'),
        Eight: require('../../images/brival/marcasCarousel/Brands_8.png'),
        Nine: require('../../images/brival/marcasCarousel/Brands_9.png'),
        Ten: require('../../images/brival/marcasCarousel/Brands_10.png'),
        Eleven: require('../../images/brival/marcasCarousel/Brands_11.png'),
        Twelve: require('../../images/brival/marcasCarousel/Brands_12.png'),
        Thirteen: require('../../images/brival/marcasCarousel/Brands_13.png'),
        Fourteen: require('../../images/brival/marcasCarousel/Brands_14.png'),
        Fifteen: require('../../images/brival/marcasCarousel/Brands_15.png'),
        Sixteen: require('../../images/brival/marcasCarousel/Brands_16.png'),
        Seventeen: require('../../images/brival/marcasCarousel/Brands_17.png'),
        Eightteen: require('../../images/brival/marcasCarousel/Brands_18.png'),
        Nineteen: require('../../images/brival/marcasCarousel/Brands_19.png'),
        Twenty: require('../../images/brival/marcasCarousel/Brands_20.png'),
        Twentyone: require('../../images/brival/marcasCarousel/Brands_21.png'),
        Twentytwo: require('../../images/brival/marcasCarousel/Brands_22.png'),
        Twentythree: require('../../images/brival/marcasCarousel/Brands_23.png'),
        Twentyfour: require('../../images/brival/marcasCarousel/Brands_24.png'),
        Twentyfive: require('../../images/brival/marcasCarousel/Brands_25.png'),
        Twentysix: require('../../images/brival/marcasCarousel/Brands_26.png'),
        Twentyseven: require('../../images/brival/marcasCarousel/Brands_27.png'),
        Twentyeight: require('../../images/brival/marcasCarousel/Brands_28.png'),
        Twentynine: require('../../images/brival/marcasCarousel/Brands_29.png'),
        Thirty: require('../../images/brival/marcasCarousel/Brands_30.png'),
        // Thirtyone: require('../../images/brival/marcasCarousel/Brands_31.png'),
    },

    openPay:{
        credit: require('../../views/validateOrder/cards1.png'),
        debit: require('../../views/validateOrder/cards2.png'),
        logo: require('../../views/validateOrder/openpay.png'),
        security: require('../../views/validateOrder/security.png'),

    },
    // <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7189.30914847664!2d-100.33297598314306!3d25.715858498446593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa82a5aab49e3b149!2sDistribuidora%20Industrial%20De%20Abrasivos%20Sa%20De%20Cv!5e0!3m2!1ses!2smx!4v1625429196137!5m2!1ses!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>

    dataSucursal: [
        {
            imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
            name: 'Matriz',
            address: 'Avenida del valle norte #928, Huechuraba, Santiago de Chile',
            zipcode: '',
            block: '',
            phones: ['226170700']
        },
        // {
        //     imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
        //     name: 'GUADALAJARA',
        //     address: 'Av. San Miguel No. 399 N° int. 46 Fracc. San Juan de Ocotán',
        //     zipcode: '45019',
        //     block: 'Zapopan, Jalisco. México.',
        //     phones: ['(333) 620 2520']
        // },
        // {
        //     imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
        //     name: 'URUAPAN',
        //     address: 'Calle Atenas #13 esquina con Manuel Pérez Coronado Col. Jardines del Cupatitzio.',
        //     zipcode: '60080',
        //     block: 'Uruapan, Michoacán. México.',
        //     phones: ['(452) 688 2033']
        // },
        // {
        //     imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
        //     name: 'SAN QUINTÍN',
        //     address: 'Carretera Transpeninsular Km 167.5, M 36, L7 S/N Ejido Emiliano Zapata',
        //     zipcode: '22920',
        //     block: 'Vicente Guerrero, B.C. México.',
        //     phones: ['(616) 165 2538']
        // }, 
        // {
        //     imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
        //     name: 'ENSENADA',
        //     address: 'Manuel Romero',
        //     zipcode: '',
        //     block: 'mromero@industriasrochin.com',
        //     phones: ['(646) 210 1459']
        // }, 
        // {
        //     imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
        //     name: 'TORREÓN',
        //     address: 'Fernando Torres',
        //     zipcode: '',
        //     block: 'ftorres@ircomx.com',
        //     phones: ['(811) 660 2500']
        // },    
        // {
        //     imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
        //     name: 'CHIHUAHUA',
        //     address: 'David Molinar',
        //     zipcode: '',
        //     block: 'dmolinar@industriasrochin.com',
        //     phones: ['(614) 176 5128']
        // },    
        // {
        //     imagen: require('../../images/brival/Sucursales/sucursal-01.png'),
        //     name: 'LOS MOCHIS',
        //     address: 'Sergio Caballet',
        //     zipcode: '',
        //     block: 'sacaballetv@ircomx.com',
        //     phones: ['(668) 125 0657']
        // }, 
    ],

    Back:{
        backgroundColor:"FFFFFF"
    },
    BarraTelefono:{
        Whats: require('../../images/irco/barraTelefono/whatsapp-verde.svg'),
        IconUbicacion: require('../../images/irco/barraTelefono/Sucursales.svg'),
        IconCel: require('../../images/irco/barraTelefono/Telefono.svg'),
    },

    dashboard: 'Carousel',
    slider: {
    },
    carousel: {
        images: []
    },

    aboutUs: {
        active: true,
        description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown 
        printer took a galley of type and scrambled it to make a type specimen book. It has survived not 
        only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. 
        It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
        and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
        mission: 'Lograr la completa satisfacción del cliente mediante el abastecimiento eficiente de productos de calidad a precios competitivos, con asesoría técnica y servicio personalizado diferenciado y permanente que asegure una relación de largo plazo con clientes, empleados y proveedores.',
        vision: 'Seremos una empresa cuya estrategia corporativa, comercial y logística nos permita satisfacer a los mercados que atendemos.',
        values: [],
        //images: require('../../images/irco/about/quienes-somos.jpg'),
    },

    contactUs: {
        active: true,
        iconColor: '#000000',
        colorOSGA: '#000000',
        locations: [
            {
                name: 'Oficina principal',
                street: 'Avenida del valle norte #928, Huechuraba. ',
                country: 'Santiago de Chile',
                phone: 'Tel: 226 170 700 ',//Whatsapp: 3313207614
                email: '',
                maps: 'https://goo.gl/maps/r2o1LG7y2QUvTdeHA',
            },
        ]
    },

    claim: {
        active: false,
    },

    termPage: {
        active: false,
    },

    questions: {
        active: false,
        bannerImage: require('../../images/brival/bannersSeccionesInformativas/pregunta-frecuentes.png'),
    },

    itemsList: {
        backgroundColor: 'rgba(255,255,255, 0.5)',
        textColor: 'rgba(0,0,0, 0.8)',
        textColor2: 'black',
        iconColor: '#a91c17',
        textPrice: 'black',
        textPrice2: 'black',
    },

    shoppingList: {
        productList: '#09488F',
        textProductList: 'white',
        summaryList: '#FFED00 !important',
        summaryList2: '#FFED00 !important',
        summaryList3: '#212529',
        textsummaryList: 'white',
        textsummaryBlack: 'black !important' ,
    },

    pdf: {
        VERterminosCondiciones: true,
        terminosCondiciones: '/images/brival/terminosCondiciones.pdf',
        VERpoliticasVentas: true,
        politicasVentas: 'politicasVentas.pdf',
        VERpoliticasEnviosGarantias: true,
        politicasEnviosGarantias: 'politicasEnviosGarantias.pdf',
        VERpoliticasGarantia: true,
        politicasGarantia: 'politicasGarantia.pdf',
        VERpoliticasUsoAvisoPrivacidad : true,
        politicasUsoAvisoPrivacidad: 'politicasUsoAvisoPrivacidad.pdf',
        politicasRecompensas: 'politicasRecompensa.pdf',
        politicasFooter: 'politicasFooter.pdf',
        nosotros: 'nosotros.pdf',
    }, 
    //Nueva linea, para tratar los botones de profile 
    profileStyles:{
        bkColor :'#ffffff',
    },

    //117
    NuevosEstilos:{
        background: {
            backgroundColor: "#FFFFFF",
        },
        catergoriasColor:{
            color: "white !important",
        },
        selector: {
            textWhiteColor: "#000000",
        },
    },

    footer: {
        icon: require('../../images/brival/footer/Logo-footer.svg'),
        power: require('../../images/irco/footer/logofmb.png'),
        backgroundColor: '#000',
        iconColor: '#666666',
        textColor: '#fff',
        fontSizeF: '1rem',

        info: {
            Icon30:  require('../../images/irco/footer/logofmb.png'),
            hoursIcon: require('../../images/irco/footer/clock-regular.svg'),
            hours: 'Lunes a Viernes 8:00 am a 6:30 pm',//Sábado 9:00 am a 2:00 pm
            calendarIcon: require ('../../images/irco/footer/envelope-regular.svg'),
            calendar: "Lunes a Viernes",
            emailIcon: require('../../images/irco/footer/envelope-regular.svg'),
            email: /*'contacto@ircomx.com'*/ 'Correo@correo.com',
            phoneIcon: require('../../images/irco/footer/phone-alt-solid.svg'),
            phone: '226 170 700',
            phoneWhats: '226 170 700',
            linkPhoneWhats: "#",
            addressIcon: 'fas fa-2x fa-location-arrow',
            address: 'Avenida del valle norte #928, Huechuraba, Santiago de Chile',
        },

        socialMedia2: [
            {
                visibility: false,
                icon: require('../../images/irco/footer/youtube.png'),
                linkref: 'https://www.youtube.com/channel/UC3XN3-TIyiQtnnELfnJZo3w',
            },
            {
                visibility: false,
                icon: require('../../images/irco/footer/instagram.svg'),
                linkref: 'https://www.instagram.com/ircomx/',
            },
            {
                visibility: false,
                icon: require('../../images/irco/footer/facebook.svg'),
                linkref: 'https://www.facebook.com/ircomx/',
            },
            {
                visibility: false,
                icon: 'fab fa-4x fa-twitter',
                linkref: 'https://twitter.com/gruporedhogar',
            },
            {
                visibility: false,
                icon: require('../../images/irco/footer/whatsap.png'),
                linkref: 'https://api.whatsapp.com/send?phone=523313207614&text=Hola%2C%20Gracias%20por%20contactar%20a%20Grupo%20Redhogar%2C%0A%C2%BFEn%20qu%C3%A9%20podemos%20apoyarlo%3F',
            },
            {
                visibility: false,
                icon: require("../../images/irco/footer/linkedin.svg"),
                linkref: 'https://www.linkedin.com/company/ircocommercial',
            },
        ]
    },

    paymentMethod: {
        paypal: {
            enable: true,
            clienId: 'AcgfSWjvFifar4P_3alUSPkhf0Z5g21gs1ieaFCF0HoFojz5GnYxYFE5L-uIH4tZEqWffcTzN_jnqf6l',
            //clienId: 'Aa2jAA2wV-jR9wXcDcaBnAatmI5nbANCx0TaQks_UWDAEKWAkuRwEvCap3krt7my-8FciPFo73rbOCJH',
        },
        transbank: {
            enable: false,
        },
        mercadoPago:{
            enable:true,
        },
        openPay:{
            enable:true,
        }
    },

    privacy:{
        banner: require('../../images/irco/avisoPrivacidad/avisoprivacidad.png'),
    },

    recompensas:{
        banner : require('../../images/irco/AboutRecompensas/banner.png'),
        card : require('../../images/irco/card.png'),
        vitrina1 : require('../../images/irco/vitrinaRedCompensas/icon-10.png'),
        vitrina2 : require('../../images/irco/vitrinaRedCompensas/icon-11.png'),
        vitrina3 : require('../../images/irco/vitrinaRedCompensas/icon-12.png'),
    },
    Avatar:{
        bronze1 : require('../../images/brival/Navbar/Avatar_principal.svg'),
        silver1 : require('../../images/irco/Avatar/silver1.png'),
        gold1 : require('../../images/irco/Avatar/gold1.png'),
        platinum1 : require('../../images/irco/Avatar/platinum1.png'),
        diamond1 : require('../../images/irco/Avatar/diamond1.png'),
        mercado1 : require('../../images/irco/Avatar/mercado1.png'),
        red1 : require('../../images/brival/Navbar/Avatar_principal.svg'),

        bronze2 : require('../../images/irco/Avatar/bronze2.png'),
        silver2 : require('../../images/irco/Avatar/silver2.png'),
        gold : require('../../images/irco/Avatar/gold2.png'),
        platinum2 : require('../../images/irco/Avatar/platinum2.png'),
        diamond2 : require('../../images/irco/Avatar/diamond2.png'),
        mercado2 : require('../../images/brival/Navbar/Avatar_principal.svg'),
        red2 : require('../../images/brival/Navbar/Avatar_principal.svg'),
        avatarB: require('../../images/brival/Navbar/Avatar_principal.svg'),
    },
    buildPage:{
        img: require('../../images/brival/HOME/PagConstruccionMillSabores2.png'),
    },
    gif:{
        gif: require('../../images/irco/GIF-prueba.gif'),
    },
    modules:{
        PageBuils: false, //Pagina de construccion
        points : false,
        pasarelaCarrito : false,
        redZone : true,
        redAliado : true,
        subirArchivoExcel : true,
        BolsaTrabajo : true,
        cupon : false,
        Comments : false,
        Devoluciones : true,
        hamburger : true,
    },

    catalogo: [
        {
            nombre: `Catálogo Uno`,
            imagen: require('../../images/irco/catalogos/1.jpg'),
            pdf: '1.pdf',
        },
        {
            nombre: `Catálogo Dos`,
            imagen: require('../../images/irco/catalogos/2.jpg'),
            pdf: '2.pdf',
        },
        {
            nombre: `Catálogo Tres`,
            imagen: require('../../images/irco/catalogos/3.jpg'),
            pdf: '3.pdf',
        }
    ],
    //LOCAL
    // BASE_URL: 'http://localhost:3053/api',
    // ASSETS: 'http://localhost:3053/api/uploads/',
    // IP PRUEBAS FMB
    // BASE_URL: 'http://192.168.0.124:3053/api',
    // ASSETS: 'http://192.168.0.124:3053/api/uploads/',

    // // IP PRUEBAS
    // BASE_URL: 'http://45.236.164.61:3040/api',
    // ASSETS: 'http://45.236.164.61:3040/api/uploads/',

    // IP PROD
    // BASE_URL: 'http://45.236.164.61:3050/api',
    // ASSETS: 'http://45.236.164.61:3050/api/uploads/',

    //PROD SSL
    BASE_URL: 'https://tienda.milsaboresfood.com:3050/api',
    ASSETS: 'https://tienda.milsaboresfood.com:3050/api/uploads/',
    
    localStorageNamed: local + 'E-commerce',
    
};